import { RawDraft } from '../../types/draft';

export const parseDraft = (json: string): RawDraft => {
  return JSON.parse(json) as RawDraft;
};
